import Skeleton from "@mui/material/Skeleton";
import { CardWrapper } from "./styles";

export default function SimilarJobSkeleton(props) {
  const { dialog } = props;
  return (
    <CardWrapper $dialog={dialog}>
      <Skeleton variant="rounded" width="100%" height="100%" />
    </CardWrapper>
  );
}
